const getNumericPart = string => parseInt(string.match(/\d+/)?.[0]);

export default getNumericPart;
